// Product imagery: ONLY user-uploaded photos. No stock/AI images.
// Missing photo => clean brand-colored tile with product initials.

export function documentUrl(value) {
  if (typeof value !== "string" || !value.trim()) return null;
  try {
    const base = new URL(process.env.REACT_APP_BACKEND_URL || window.location.origin, window.location.origin);
    const prefix = base.pathname.replace(/\/+$/, "");
    const target = new URL(value.startsWith("/") && !value.startsWith("//") ? prefix + value : value, base.origin + prefix + "/");
    if (!/^https?:$/.test(base.protocol) || !/^https?:$/.test(target.protocol) || target.username || target.password) return null;
    // Session auth belongs only to this backend's authenticated file handler.
    if (target.origin === base.origin && target.pathname.startsWith(prefix + "/api/files/")) {
      target.searchParams.delete("auth");
      const token = localStorage.getItem("groot_token");
      if (token) target.searchParams.set("auth", token);
    }
    return target.href;
  } catch {
    return null;
  }
}

export function fileUrl(url) {
  if (typeof url !== "string" || !url) return null;
  if (url.startsWith("data:") || url.startsWith("blob:")) return url;
  return documentUrl(url);
}

export function productImage(p) {
  const imgs = (p && p.images) || [];
  return imgs.length ? fileUrl(imgs[0]) : null;
}

const ACCENTS = [
  "from-emerald-500 to-emerald-700",
  "from-orange-400 to-orange-600",
  "from-teal-500 to-emerald-700",
  "from-amber-400 to-orange-600",
  "from-green-600 to-teal-700",
  "from-lime-500 to-emerald-600",
];

export function catAccent(key = "") {
  let h = 0;
  for (let i = 0; i < key.length; i++) h = (h * 31 + key.charCodeAt(i)) & 0xffff;
  return ACCENTS[Math.abs(h) % ACCENTS.length];
}

export function initials(name = "") {
  const parts = name.trim().split(/\s+/).filter(Boolean);
  if (!parts.length) return "";
  return (parts[0][0] + (parts[1]?.[0] || "")).toUpperCase();
}
